export const DAYS_IN_WEEK = 7
export const WEEK_START = 0
export const TASK_HEIGHT = 36
export const TASK_OFFSET = 5
export const DAY_BOTTOM_PADDING = 30
export const DAY_TOP_PADDING = 32

export const ItemTypes = {
    HANDLE: 'handle'
}

export const DAYS_OF_WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

export const TOOLTIP_STATES = {
    NONE: 'none',
    SELECT_CALENDARS: 'selectCalendars',
    SWITCH_ON_OFF: 'switchOnOff',
    MOVE: 'move',
    RESIZE: 'resize'
}

export const ENABLE_CALENDAR_ID = 4
export const CHANGE_TASK_ID = 2
